import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { useThemeMode } from '../../contexts/ThemeModeContext';

// Default app logo — shown wherever no firm-specific logo is configured
// (sidebar, login/register/forgot-password, favicon/app icons). The white
// variant is for dark surfaces (dark mode, or anywhere with a dark
// background) — the colored one reads as near-black glow on those.
export const ONIN_LOGO_LIGHT = `${process.env.PUBLIC_URL}/assets/onin-lcm-logo.png`;
export const ONIN_LOGO_DARK = `${process.env.PUBLIC_URL}/assets/onin-lcm-logo-white.png`;

interface BrandLogoProps {
  height?: number | string;
  sx?: SxProps<Theme>;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ height = 56, sx }) => {
  const { mode } = useThemeMode();
  return (
    <Box
      component="img"
      src={mode === 'dark' ? ONIN_LOGO_DARK : ONIN_LOGO_LIGHT}
      alt="ONIN Legal Case Manager"
      sx={{ height, width: 'auto', maxWidth: '100%', objectFit: 'contain', ...sx }}
    />
  );
};

export default BrandLogo;
